import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const postPolicyAccept = createAsyncThunk(
  "policy/postPolicyAccept",
  async (
    { policyId, userId, readTime, accepted },
    { rejectWithValue }
  ) => {
    try {
      const url = api.postPolicyAcceptApi;
      const payload = {
        policyId,
        userId,
        readTime,
        accepted,
      };
      const response = await axiosPrivate.post(url, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        "Unable to accept policy"
      );
    }
  }
);


const postPolicyAcceptSlice = createSlice({
  name: "postPolicyAccept",
  initialState: {
    data: null,
    status: "idle",
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    resetPostPolicyAccept: (state) => {
      state.status = "idle";
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postPolicyAccept.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(postPolicyAccept.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(postPolicyAccept.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetPostPolicyAccept } = postPolicyAcceptSlice.actions;
export default postPolicyAcceptSlice.reducer;
